import { IStoreSdk } from "./types";

export const SDK = {
    instance: {
        supports: {}
    } as IStoreSdk
};

export function setSdk(sdk: IStoreSdk) {
    SDK.instance = sdk;
}